import React, { useContext, useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { LanguageContext } from "../context/LanguageContext";
import { GERMAN } from "../actions/language";

const Cookies = () => {
    const { language } = useContext(LanguageContext);
    const [showBanner, setShowBanner] = useState(null);

    useEffect(() => {
        const accepted = localStorage.getItem("cookiesAccepted");
        if (accepted === "true" || accepted === "false") {
            setShowBanner(false);
        } else {
            setShowBanner(true);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem("cookiesAccepted", "true");
        setShowBanner(false);
        console.log("Cookies akzeptiert");
    };

    const handleDecline = () => {
        localStorage.setItem("cookiesAccepted", "false");
        setShowBanner(false);
        console.log("Nur notwendige Cookies akzeptiert");
    };

    if (showBanner === null) return null;
    if (!showBanner) return null;

    return (
        <div id="cookie-banner" className="cookie-banner border-4">
            <div id="ignilabs-logo">
                <img src="/img/ignilabs.png" alt="IgniLabs" />
                <span>IgniLabs</span>
            </div>
            <div id="cookie-body">
                <h4>
                    <b>
                        {language === GERMAN ? 'Diese Webseite verwendet Cookies' : 'Este sítio Web utiliza cookies'}
                    </b>
                </h4>
                {
                    language === GERMAN ? 'Wir verwenden Cookies um Inhalte und Anzeigen zu personalisieren, Funktionen für soziale Medien anbieten zu können und die Zugriffe auf unsere Website zu analysieren. Außerdem geben wir Informationen zu Ihrer Verwendung unserer Website an unsere Partner für soziale Medien, Werbung und Analysen weiter. Unsere Partner führen diese Informationen möglicherweise mit weiteren Daten zusammen, die Sie ihnen bereitgestellt haben oder die sie im Rahmen ihrer Nutzung der Dienste gesammelt haben.' : 'Utilizamos cookies para personalizar o conteúdo e os anúncios, para oferecer funções para as redes sociais e para analisar o acesso ao nosso sítio Web. Também partilhamos informações sobre a sua utilização do nosso sítio Web com os nossos parceiros de redes sociais, publicidade e análise. Os nossos parceiros podem combinar estas informações com outros dados que lhes tenha fornecido ou que tenham recolhido no âmbito da sua utilização dos serviços.'
                }
                <Link to="/data-protection" target="_blank" className="small">{language === GERMAN ? 'Mehr erfahren ...' : 'Saiba mais ...'}</Link>
            </div>
            <div className="cookie-buttons d-flex flex-column">
                <button onClick={handleAccept} className="btn btn-primary">{language === GERMAN ? 'Alle akzeptieren' : 'Aceitar tudo'}</button>
                <button onClick={handleDecline} className="btn btn-secondary">{language === GERMAN ? 'Nur notwendige akzeptieren' : 'Aceitar apenas o necessário'}</button>
            </div>
        </div>
    );
};

export default Cookies;



// WEBPACK FOOTER //
// ./src/components/Cookies.js